<template>
  <div>
    <div>
      <el-table :data="terminalTaskList" border height="400" stripe>
        <el-table-column :label="$t('message.downloadTask')" prop="taskName" />
        <el-table-column :label="$t('message.type')" prop="taskType" width="150">
          <template slot-scope="scope">
            <span v-if="scope.row.taskType == 0" size="small">{{ $t('message.appDownload') }}</span>
            <span v-if="scope.row.taskType == 1" size="small">{{ $t('message.appParam') }}</span>
            <span v-if="scope.row.taskType == 2" size="small">{{ $t('message.terminalParam') }}</span>
            <span v-if="scope.row.taskType == 3" size="small">{{ $t('message.appDelete') }}</span>
            <span v-if="scope.row.taskType == 4" size="small">{{ $t('message.appResourceFile') }}</span>
          </template>
        </el-table-column>
        <el-table-column :label="$t('message.status')" width="150">
          <template slot-scope="scope">
            <span v-if="scope.row.terminalTaskStatus == 0 && scope.row.deliverStatus == 0">{{$t('message.notStart')}}</span>
            <span v-if="scope.row.terminalTaskStatus == 0 && scope.row.deliverStatus == 1">{{$t('message.downloading')}}</span>
            <span v-if="scope.row.terminalTaskStatus == 1">{{$t('message.downSuccess')}}</span>
            <span v-if="scope.row.terminalTaskStatus == 2">{{$t('message.downFail')}}</span>
            <span v-if="scope.row.terminalTaskStatus == 3">{{$t('message.installSuccess')}}</span>
            <span v-if="scope.row.terminalTaskStatus == 4">{{$t('message.installFail')}}</span>
            <span v-if="scope.row.terminalTaskStatus == 5">{{$t('message.delSuccess')}}</span>
            <span v-if="scope.row.terminalTaskStatus == 6">{{$t('message.delFail')}}</span>
          </template>
        </el-table-column>
        <el-table-column :label="$t('message.createTime')" prop="createTime" width="160"/>
        <el-table-column :label="$t('message.creator')" prop="name" />
      </el-table>
    </div>
    <div>
      <el-pagination background layout="prev, pager, next" @current-change="queryTerminalTask" :current-page="pageNum" :page-count="pages" />
    </div>
  </div>
</template>

<script>
    export default {
      name: "TerminalEditTaskList",

      props: {
        terminalId:{
          required: true
        }
      },

      data(){
        return{
          pageSize: 10,
          pageNum: 1,
          pages: 0,
          terminalTaskList: []
        }
      },

      watch:{
        terminalId:function(){
          this.queryTerminalTask(1);
        }
      },

      methods: {
        queryTerminalTask(pageNum){
          let _this = this,
            obj = {
              pageNum: pageNum,
              pageSize: this.pageSize,
              terminalId: this.terminalId
            };
          console.log(obj)
          this.$axios({
            method: 'post',
            url: '/marketplace/taskTerminal/terminalEdit',
            data: obj,
            headers: {
              'Accept-Language': sessionStorage.getItem('acceptLanguage')
            }
          }).then(response => {
            if (response.data.code != "00") {
              _this.$message({
                type: "error",
                message: response.data.desc,
                duration: '3000',
              });
              return;
            } else {
              this.pages = response.data.data.pages;
              this.terminalTaskList = response.data.data.list;
            }
          }).catch((err) => {
            console.log(err);
          });

        }

      }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/page/terminal/TerminalEditTaskList.vue